import React from "react";
import { Container, Box, Typography } from "@mui/material";

const SuccessPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box textAlign="center">
        <Typography
          variant="h4"
          sx={{ fontFamily: "basic-sans", fontWeight: 700 }}
        >
          Your purchase was successful!
        </Typography>
      </Box>
    </Container>
  );
};

export default SuccessPage;
